export const ROLES = {
    DEALER_ADMIN: 'ROLE_DEALER_ADMIN',
    DEALER_USER: 'ROLE_DEALER_USER',
}

export const ROLES_INFO = {
    [ROLES.DEALER_ADMIN]: {
        title: 'Dealer Admin'
    },
    [ROLES.DEALER_USER]: {
        title: 'Dealer User'
    },
}